import { ListGroupItemText as _ListGroupItemText, ListGroupItemTextProps as _ListGroupItemTextProps } from "reactstrap";

    export const ListGroupItemText = _ListGroupItemText;
    export type ListGroupItemTextProps = _ListGroupItemTextProps;
    